import { render, staticRenderFns } from "./Asignaturas.vue?vue&type=template&id=57871130&"
import script from "./Asignaturas.vue?vue&type=script&lang=js&"
export * from "./Asignaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports